import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";

import {
  Badge,
  Modal,
  ModalBody,
  ModalHeader,
  Notification,
  NotificationType,
} from "@transfr-inc/dashboard-components";

import { useDownloadPathwayPDF } from "@lib/hooks";
import { ANNUAL_HOURS_WORKED } from "@src/services";

import { IncomeRate } from "@views/classrooms/details/components/income-rate";

import "./career-plans.modal.scss";

export const CareerPlansModal = ({ onClose, classroom, trainee }) => {
  const [notification, setNotification] = useState();
  const { isGeneratingPDF, doDownloadPathwayPDF } = useDownloadPathwayPDF({
    classroom,
    trainee,
    setNotification,
  });

  const careerPlans = trainee?.careerPlans ?? [];

  return (
    <Modal
      open={careerPlans.length > 0}
      onClose={onClose}
      modalClassName="career-plans-modal"
    >
      <ModalHeader>
        <div className="career-plans-modal-header">
          <h2 className="text">Pathways Selected</h2>
          <Badge value={careerPlans.length} />
        </div>
      </ModalHeader>
      <ModalBody>
        <div className="career-plans-modal-content">
          {careerPlans.map((careerPlan) => {
            const career = careerPlan.career;
            return (
              <div key={careerPlan.id} className="career-plan-item">
                <div className="career-plan-item-content">
                  {!careerPlan.deletedAt && (
                    <div className="latest">
                      <FontAwesomeIcon icon={["fa-regular", "circle-check"]} />
                      Latest
                    </div>
                  )}
                  <div className="career-title-and-income-rate">
                    <div className="career-title">{career.title}</div>
                    <IncomeRate
                      value={
                        career?.hourlyEarningsMedian ??
                        career?.annualEarningsMedian / ANNUAL_HOURS_WORKED
                      }
                    />
                  </div>
                  <p className="description">{career.shortDescription}</p>
                </div>
                <div className="career-plan-item-actions">
                  <FontAwesomeIcon
                    icon={["fa-light", "download"]}
                    onClick={() => doDownloadPathwayPDF(careerPlan.id)}
                  />
                </div>
              </div>
            );
          })}
        </div>
        <div className="update-notification-container">
          {isGeneratingPDF && (
            <Notification
              type={NotificationType.info}
              icon={["fa-solid", "spinner"]}
              iconConfig={{ spin: true }}
            >
              <div className="update-message">Generating PDF...</div>
            </Notification>
          )}
          {notification && (
            <Notification
              type={notification.type}
              icon={notification.icon}
              closable
              onClose={() => setNotification()}
            >
              {notification.message}
            </Notification>
          )}
        </div>
      </ModalBody>
    </Modal>
  );
};
